/**
 * Created by mac on 2/3/23
 */

const ToolMenuItem = function (toolEntry, parent, key) { 
    this.entry = toolEntry;
    this.parent = parent;
    this.key = key;
};

ToolMenuItem.SUB_ITEM = "•  ";
ToolMenuItem.ACTIVE_ITEM = "※ ";
ToolMenuItem.DONE_ITEM = "✔ ";

ToolMenuItem.prototype.isRoot = function () {
    return this.parent === null;
};

ToolMenuItem.prototype.isFolder = function () {
    return this.children() !== undefined;
};

ToolMenuItem.prototype.isFlag = function () {
    return this.entry && this.entry.flag;
};

ToolMenuItem.prototype.children = function () {
    let children = undefined;

    if (this.entry instanceof ToolFolder) {
        children = this.entry.listItems();
    } else if (typeof this.entry === "object" && !this.isFlag()) {
        children = this.entry;
    }

    if (!children) {
        return undefined;
    }

    const entries = {};
    Object.keys(children).forEach((key) => {
        const entry = children[key] instanceof ToolEntry ? children[key].isAvailable() && children[key].entry : children[key];
        if (entry instanceof ToolFolder ? entry.listItems() : entry) {
            entries[key] = entry;
        }
    });

    return Object.keys(entries).map(function (key) {
        return new ToolMenuItem(entries[key], this, key);
    }, this);
};

ToolMenuItem.prototype.clickHandler = function () {
    if (this.isFolder()) {
        cleverapps.toolModel._navigate(this);
    } else if (this.isFlag()) {
        cleverapps.flags.toggle(this.entry.flag);
        cleverapps.toolModel.refresh();
    } else {
        this.entry();
    }
};

ToolMenuItem.prototype.extractPath = function () {
    const path = [];

    for (let item = this; item; item = item.parent) {
        path.push(item.key);
    }

    return path.reverse().slice(1).join("/");
};